export default __webpack_public_path__ + "static/media/icon-link.0e8e8822.svg";